/**
 * Where a pipeline card opens to, by the module that produced it.
 *
 * A module missing from this table has no single detail route a card can open,
 * so its cards render as plain text rather than links.
 */
export const MODULE_ROUTES: Record<string, string[]> = {
    reports: ["/reports-v2"],
    hazardRegister: ["/risk-management/hazard-register"],
    riskEvaluations: ["/risk-management/evaluations"],
    safetyCases: ["/assurance/registry"],
    internalAudits: ["/assurance/internal-audit"],
    inspections: ["/assurance/inspections"],
    promotions: ["/promotions"],
    meetings: ["/promotions/meeting-minutes"],
    safetyObjectives: ["/policies/objectives"],
};

/**
 * The plan that fills a stage, named on a locked column.
 *
 * Kept here rather than sent by the server, which never returns display text:
 * the server says a stage is locked, this says which plan would open it.
 */
export const STAGE_UNLOCKED_BY: Record<string, string> = {
    promoted: "SMS Suite",
};
